import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

import CreateIcon from "@material-ui/icons/Create";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { AuthProvider } from "@src/Interfaces/Entity/OAuthProvider";
import { Dialog, DialogContent } from "@material-ui/core";
import AuthProviderForm from "../AuthProviderForm/AuthProviderForm";
import { IValuesStore } from "@src/Stores/Values/types";
import { IFile } from "@src/Interfaces/Entity/File";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  oAuthProvider: AuthProvider;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
export default class EditAuthProvider extends React.Component<IProps> {
  @observable editOpened: boolean = false;

  handleOpenEdit = () => {
    this.editOpened = true;
  };
  handleCloseEdit = () => {
    this.editOpened = false;
  };

  handleUpdate = async (values: AuthProvider) => {
    if (values.type === this.props.values.oAuthProviderTypes.Custom && values.fileImage) {
      if (values.fileImage.name === "reset") {
        values.iconId = this.props.values.common.EmptyId;
        values.iconUrl = "";
      } else if (values.fileImage.name !== "default") {
        const file: IFile = await this.props.management.uploadFile(
          values.fileImage,
          values.id,
          this.props.values.fileTypes.OAuthProviderIconImage
        );
        values.iconId = file.id;
        values.iconUrl = file.url;
      }
    }

    await this.props.management.saveOAuthProvider(values);
    await this.props.management.getOAuthProviders();
    this.editOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <RoundButton
          icon={<CreateIcon/>}
          tooltipTitle={Values.getLocalizationValue("edit")}
          onClick={() => this.handleOpenEdit()}
        />

        <Dialog open={this.editOpened} onClose={this.handleCloseEdit}>
          <DialogContent>
            <AuthProviderForm
              title={Values.getLocalizationValue("add")}
              initialValues={this.props.oAuthProvider}
              onSubmit={this.handleUpdate}
              onClose={this.handleCloseEdit}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
